import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { NavContext } from '../../../../context/global_context'
import InlineCheckbox from '../../../common/InlineCheckbox'

const ItemRow = (props) => {
  const {
    inputName,
    name,
    value,
    onChange,
    description,
    isChecked,
    isSelected,
    formRef,
  } = props
  const [navState, navDispatch] = useContext(NavContext)

  useEffect(() => {
    if(!formRef) return

    formRef.setFieldValue(inputName, isChecked)
  }, [formRef, inputName, isChecked])

  return (
    <InlineCheckbox
      name={inputName}
      label={
        <>
          <span className='name bolder'>{name}</span>
          <span className='description'>{description}</span>
          <span className='harness'>{props.children}</span>
        </>
      }
      value={isChecked}
      onChange={(value) => onChange(value)}
    />
  )
}

ItemRow.propTypes = {
  name: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  description: PropTypes.string,
  isChecked: PropTypes.bool,
  isSelected: PropTypes.bool,
}

export default ItemRow
